import { type User } from '@supabase/supabase-js'
import { useRouteLoaderData } from 'react-router'

interface UseUserReturn {
	isSignedIn: boolean
	isLoaded: boolean
	user: User | null
}

/**
 * Drop-in replacement for Clerk's useUser hook
 * Gets user data from the root loader instead of client-side context
 */
export function useUser(): UseUserReturn {
	const rootData = useRouteLoaderData('root') as { user?: User | null } | null
	const user = rootData?.user || null

	return {
		isSignedIn: !!user,
		isLoaded: true, // Always loaded since it comes from the server
		user,
	}
}
